module.exports = __webpack_public_path__ + "media/images/bridge-map-9d9b303007e452187062d53c55d53212.svg";